import React, { JSX } from 'react';
import { useNavigate } from 'react-router-dom'; // Aggiungi l'importazione per il navigatore, se non già presente
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import IosShareIcon from '@mui/icons-material/IosShare';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

// Definizione delle props per il componente
interface MasterHeaderProps {
  tipo: string;
  nomeElemento: string;
  statoBadge: JSX.Element;
  elimina: () => void;
  salvaModifica: () => void;
  aggiornaPubblicazione: () => void;
  actionButtonName?: string
  status: string;
  stateSave: boolean;
  statePublished: boolean;
  isEdit?: boolean;
  deleteDisabled?: boolean;
}

const MasterHeader: React.FC<MasterHeaderProps> = ({
  tipo,
  statoBadge,
  elimina,
  nomeElemento,
  salvaModifica,
  aggiornaPubblicazione,
  actionButtonName,
  status,
  stateSave,
  statePublished,
  isEdit,
  deleteDisabled,
}) => {
  const navigate = useNavigate();

  return (
    <div id="masterheader" className="p-4 shadow-sm" style={{ flexShrink: 0, backgroundColor: "#F3F3F3" }}>
      <div className='row'>
        <div className='col align-self-start'>
          <button className="btn btn-light" onClick={() => navigate(-1)} style={{ whiteSpace: 'nowrap' }}>
            <ArrowBackIcon />
            Torna indietro
          </button>
        </div>
        <div className='col align-self-end text-end'>
          <button 
            className="btn btn-danger" 
            disabled={deleteDisabled}
            onClick={elimina}>
            <DeleteIcon />
          </button>
        </div>
      </div>

      <div className='row mt-3'>
        <div className='col-7 align-self-start'>
          <div style={{ whiteSpace: 'nowrap', height: "3vh" }}>
            {tipo} - {statoBadge}
          </div>
          <div style={{ whiteSpace: 'nowrap', height: "5vh" }}>
            <h1 style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {nomeElemento}
            </h1>
          </div>
        </div>
        <div className='col-3' />
        
        <div className='col-2 align-self-end text-end'>
          <div className='d-flex' style={{ height: "3vh" }} />
          <div className='d-flex justify-content-end' style={{ height: "5vh" }}>
            <div className='me-3'>
              <button 
                className="btn btn-light" 
                onClick={salvaModifica} 
                style={{ whiteSpace: 'nowrap' }} 
                disabled={stateSave}
              >
                {isEdit 
                  ? (<EditIcon /> )
                  : (<IosShareIcon />)
                }
                {actionButtonName ? actionButtonName :"Salva"}
              </button>
            </div>
            <div>
              <button
                className={status === "Published" ? "btn btn-light" : "btn btn-outline-success"}
                onClick={aggiornaPubblicazione}
                disabled={statePublished}
                style={{ whiteSpace: 'nowrap' }}
              >
                <PhoneIphoneIcon />
                {status === "Published" ? "Disattiva in app" : "Pubblica in app"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterHeader;
